import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { authRedirectGuard } from './guards/auth-redirect.guard';

export const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  {
    path: 'login',
    canActivate: [authRedirectGuard],
    loadComponent: () => import('./routes/auth/auth/auth.component').then(mod => mod.AuthComponent)
  },
  {
    path: 'reset-password',
    canActivate: [authRedirectGuard],
    loadComponent: () =>
      import('./routes/auth/reset-password/reset-password.component').then(m => m.ResetPasswordComponent)
  },
  {
    path: '', loadComponent: () => import('./layout/layout/layout.component').then(mod => mod.LayoutComponent),
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'inicio', pathMatch: 'full' },
      {
        path: 'inicio',
        loadComponent: () => import('./routes/dashboard/dashboard.component').then(mod => mod.DashboardComponent)
      },
      {
        path: 'expansiones',
        loadChildren: () => import('./routes/expansiones/expansiones.routes').then(mod => mod.EXPANSIONES_ROUTES)
      },
      {
        path: 'mis-cartas',
        loadComponent: () => import('./routes/my-card-list/my-card-list.component').then(mod => mod.MyCardListComponent)
      },
      {
        path: 'mi-perfil',
        loadComponent: () => import('./routes/profile/profile.component').then(mod => mod.ProfileComponent)
      },
      {
        path: 'mis-colecciones',
        loadChildren: () => import('./routes/colections/collection.routes').then(mod => mod.COLLECTIONS_ROUTES)
      },
      { path: '**', loadComponent: () => import('./routes/error-page/error-page.component').then(mod => mod.ErrorPageComponent), pathMatch: 'full' },
    ]
  },
  { path: '**', redirectTo: '/login', pathMatch: 'full' },

];


